import { TrpTruckkArrivalDetail } from './TrpTruckkArrivalDetail';
import { TrpTruckkArrival } from './TrpTruckkArrival';

export class LHContract {
    public TRPTRUCKARRIVAL: TrpTruckkArrival | undefined;
    public TRPTRUCKARRIVALDETAILList: TrpTruckkArrivalDetail[] = [];
}